import css from '../../../utils/css';

export default css`
  @font-face {
    font-family: FANtastic-FOX;
    src:
      url(https://statics.foxsports.com/static/orion/fonts/fs-FANtastic-FOX/FS-FANtastic-FOX.woff2)
        format('woff2'),
      url(https://statics.foxsports.com/static/orion/fonts/fs-FANtastic-FOX/FS-FANtastic-FOX.woff)
        format('woff'),
      url(https://statics.foxsports.com/static/orion/fonts/fs-FANtastic-FOX/FS-FANtastic-FOX.otf)
        format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: HaasGrotTextR-55Roman;
    src: url(https://statics.foxsports.com/static/orion/fonts/haas/HaasGrotTextR-55Roman.otf)
      format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: ProximaNova;
    src: url(https://statics.foxsports.com/static/orion/fonts/proxima-nova/ProximaNova-Regular.otf)
      format('opentype');
    font-display: swap;
  }

  :host {
    --white: #ffffff;
    --black: #000000;

    --fox-white: #e5e5e5;
    --fox-blue: #0059b5;
    --fox-white-blue: #edf3fa;
    --fox-light-blue: #77a6d7;
    --fox-grey: #757575;

    --fox-font-family-1: 'HaasGrotTextR-55Roman';
    --fox-font-family-2: 'FANtastic-FOX';
    --fox-font-family-3: 'ProximaNova';

    --radius-1: 30px;
    --odds-width: 74px;
    --ogm-grid-bookmaker-cell-scale-desktop: 1.1;
    --ogm-grid-cell-height-desktop: 42px;

    /* Module */
    --widget-font-family: var(--fox-font-family-1), sans-serif;
    --widget-background-color: var(--white);
    --widget-text-color: var(--black);
    --widget-subtext-color: #9d9da3;
    --widget-border-color: var(--fox-white);
    --widget-divider-color: var(--fox-white);

    --widget-odds-drifting-bg: transparent;
    --widget-odds-drifting: transparent;
    --widget-odds-shortening-bg: transparent;
    --widget-odds-shortening: transparent;
    --widget-showmore-color: var(--fox-grey);
    --widget-showmore-font-family: var(--fox-font-family-3);

    /* Best Odds Module */
    --widget-header-bg-color: #f7f7f7;
    --widget-header-text-color: var(--black);
    --widget-header-odds-bg-color: var(--white);
    --widget-header-odds-shadow: transparent;
    --widget-header-font-family: var(--fox-font-family-2);
    --widget-header-text-transform: uppercase;
    --widget-grid-compare-active-color: var(--white);
    --widget-grid-compare-active-bg-color: var(--black);
    --widget-grid-compare-font-family: var(--fox-font-family-3);
    --widget-best-odds-border-radius: var(--radius-1);
    --widget-best-odds-border-width: 1px;
    --widget-best-odds-border-color: var(--fox-white);
    --widget-best-odds-width: var(--odds-width);
    --widget-best-odds-font-size: 14px;
    --widget-best-odds-font-family: var(--fox-font-family-2);

    /* Odds Grid Module */
    --widget-grid-header-font-family: var(--fox-font-family-2);
    --widget-grid-header-text-transform: uppercase;
    --widget-bookies-label-text-transform: uppercase;
    --widget-bookies-label-font-size: 11px;
    --widget-bookies-label-font-family: var(--fox-font-family-3);
    --widget-bookies-label-font-weight: 400;
    --widget-grid-ribbon-bg-color: transparent;
    --widget-grid-ribbon-color: transparent;
    --widget-grid-column-width: var(--odds-width);
    --widget-grid-cell-gap: 8px;
    --widget-grid-cell-width: var(--odds-width);
    --widget-grid-odds-bg-color: var(--white);
    --widget-grid-odds-border-radius: var(--radius-1);
    --widget-grid-odds-font-family: var(--fox-font-family-2);
    --widget-grid-odds-font-size: 14px;
    --widget-grid-odds-font-weight: 700;
    --widget-grid-odds-border-color: var(--fox-white);
    --widget-grid-odds-border-width: 1px;
    --widget-grid-best-odds-bg-color: var(--fox-white-blue);
    --widget-grid-best-odds-border-color: var(--fox-light-blue);
    --widget-grid-best-odds-border-width: 1px;
    --widget-grid-best-odds-text-color: var(--fox-blue);

    /* Module Mobile */
    --widget-mobile-seeall-color: var(--fox-grey);
    --widget-mobile-seeall-font-family: var(--fox-font-family-3);
    --widget-mobile-seeall-text-transform: uppercase;

    /* Odds Grid Module Mobile */
    --widget-grid-odds-mobile-bg-color: var(--white);
    --widget-grid-odds-mobile-border-radius: var(--radius-1);
    --widget-grid-odds-mobile-font-family: var(--fox-font-family-2);
    --widget-grid-odds-mobile-font-size: 14px;
    --widget-grid-odds-mobile-font-weight: 700;
    --widget-grid-odds-mobile-border-color: var(--fox-white);
    --widget-grid-odds-mobile-border-width: 1px;
    --widget-grid-best-odds-mobile-bg-color: var(--white);
    --widget-grid-best-odds-mobile-border-color: var(--fox-light-blue);
    --widget-grid-best-odds-mobile-border-width: 1px;
    --widget-grid-best-odds-mobile-text-color: var(--fox-blue);
    --widget-grid-cell-mobile-width: var(--odds-width);
  }

  /* Grid Toggler alignment, could be useful to move to base or to cx-module */
  [class*='GridToggler'] {
    margin-left: 0;
    border-bottom-left-radius: 5px;
  }

  /* Hide Best odds patch and legend for mobile */
  [class*='OddsInfoWrapper'],
  [class*='OddsRow'] [class*='bestOddsStyles'] {
    display: none;
  }

  [class*='OffersSection']:has([class*='OffersLabel']) {
    margin-top: 35px !important;
  }

  [class*='MarketExpanderBetWrapper'],
  [class*='BetBestOddsButtonWrapper'] {
    button {
      --oc-best-odds-height: 32;
      --oc-best-odds-width: 90;
      &:hover {
        background: transparent;
      }
    }
    [class*='logoWrapper'] {
      height: unset;
      max-height: 100%;
      margin-left: 3px;
      min-width: 26px;
      width: 26px;
      border-radius: 62px;
    }
  }
`;
